import { PlanRequest } from "./plan.request";


export interface PlanWithLocationRequest extends PlanRequest {
  postalCodes?: string[];
  productIds?: string [];
}
